import {
  IPAD_LANDSCAPE_WIDTH,
  PARCC_TIMED_TOOLS_COLLAPSE_WIDTH,
} from '../../constants/others'

/**
 * Collapse PARCC-family inline tool strips into a tools modal below the
 * applicable width. Timed assignments use a higher threshold because the
 * timer causes the tool strip to wrap before iPad landscape width.
 *
 * @param {number|null|undefined} windowWidth
 * @param {{ timedAssignment?: boolean }} [options]
 * @returns {boolean}
 */
export const shouldCollapseAssessmentTools = (
  windowWidth,
  { timedAssignment = false } = {}
) => {
  if (windowWidth == null) {
    return false
  }
  const collapseBelow = timedAssignment
    ? PARCC_TIMED_TOOLS_COLLAPSE_WIDTH
    : IPAD_LANDSCAPE_WIDTH
  return windowWidth < collapseBelow
}
